<script setup>
import { nextTick, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import OrderActionSummary from './OrderActionSummary.vue';

const props = defineProps({ busy: { type: Boolean, default: false } });
const emit = defineEmits(['confirm']);
const { t } = useI18n();
const dialog = ref(null);
const action = ref(null);
const executes = ref(false);
const open = async (request, executeImmediately) => {
  if (props.busy || !request) return;
  action.value = JSON.parse(JSON.stringify(request));
  executes.value = executeImmediately;
  await nextTick();
  dialog.value.open();
};
const close = () => dialog.value?.close();
const confirm = () => {
  if (props.busy || !action.value) return;
  const request = action.value;
  action.value = null;
  close();
  emit('confirm', request);
};
defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialog"
    :title="t('ORDER_ACTIONS.CONFIRM_TITLE')"
    :description="
      t(
        executes
          ? 'ORDER_ACTIONS.CONFIRM_EXECUTES'
          : 'ORDER_ACTIONS.CONFIRM_WAITS'
      )
    "
    overflow-y-auto
    @confirm="confirm"
  >
    <OrderActionSummary v-if="action" :action="action" />
    <template #footer>
      <div class="flex w-full min-w-0 flex-col gap-3 sm:flex-row">
        <Button
          type="button"
          class="w-full"
          variant="faded"
          color="slate"
          :label="t('ORDER_ACTIONS.GO_BACK')"
          :disabled="busy"
          @click="close"
        />
        <Button
          type="button"
          class="w-full"
          :label="
            t(
              executes
                ? 'ORDER_ACTIONS.CONFIRM_RUN'
                : 'ORDER_ACTIONS.CONFIRM_SEND'
            )
          "
          :disabled="busy || !action"
          @click="confirm"
        />
      </div>
    </template>
  </Dialog>
</template>
